import { alpha } from '@mui/material';
import { getTaskColor, getTaskTextColor } from '../../../features/tasks/utils/taskStateUtils';

/**
 * Get task colors based on task state and type (ghost vs. real)
 * @param {Object} task - The task object
 * @param {Object} theme - Material-UI theme object
 * @returns {Object} Object containing taskColor and textColor
 */
export const getTaskColors = (task, theme) => {
  const isGhost = task.isGhost || false;
  const originalTask = task.originalTask || task;

  let taskColor, textColor;

  if (isGhost) {
    // Always use gray color scheme for ghost tasks
    taskColor = alpha(theme.palette.grey[500], 0.4);
    textColor = theme.palette.grey[50];
  } else {
    // Use original task colors for real tasks
    taskColor = getTaskColor(originalTask);
    textColor = getTaskTextColor(originalTask);
  }

  return { taskColor, textColor };
};
